<huron-header
  class="layout-header"
  [menuToggleEnabled]="true"
  (menuToggle)="toggleMenu()"
  [user]="user"
  [showApplications]="showApplications"
  [showNotifications]="showNotifications">
</huron-header>

<dx-drawer
  class="layout-body"
  position="before"
  [closeOnOutsideClick]="shaderEnabled"
  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [shading]="shaderEnabled"
  [(opened)]="menuOpened">

  <huron-side-navigation-menu
    [sideNavItems]="sideNavItems"
    [user]="user"
    [compactMode]="!menuOpened"
    [selectedItem]="selectedRoute"
    class="dx-swatch-additional"
    *dxTemplate="let dataMenu of 'panel'"
    (selectedItemChanged)="navigationChanged($event)"
    (menuToggle)="toggleMenu()"
    >
  </huron-side-navigation-menu>

  <div class="wrapper">
    <main class="content">
      <ng-content select="[page-content]"></ng-content>
      <router-outlet>
      </router-outlet>
    </main>
    <app-footer class="footer"></app-footer>
  </div>
</dx-drawer>

<dx-load-panel
#loadPanel
shadingColor="rgba(0,0,0,0.4)"
[position]="{ of: '#pageContent' }"
[(visible)]="isLoading"
[showIndicator]="true"
[showPane]="true"
[shading]="true"
[hideOnOutsideClick]="false">
</dx-load-panel>
